"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _arEG = _interopRequireDefault(require("./ar-EG.json"));

var _arJO = _interopRequireDefault(require("./ar-JO.json"));

var _arSA = _interopRequireDefault(require("./ar-SA.json"));

var _bgBG = _interopRequireDefault(require("./bg-BG.json"));

var _caES = _interopRequireDefault(require("./ca-ES.json"));

var _csCZ = _interopRequireDefault(require("./cs-CZ.json"));

var _daDK = _interopRequireDefault(require("./da-DK.json"));

var _deDE = _interopRequireDefault(require("./de-DE.json"));

var _elGR = _interopRequireDefault(require("./el-GR.json"));

var _enUS = _interopRequireDefault(require("./en-US.json"));

var _esES = _interopRequireDefault(require("./es-ES.json"));

var _etEE = _interopRequireDefault(require("./et-EE.json"));

var _euES = _interopRequireDefault(require("./eu-ES.json"));

var _fiFI = _interopRequireDefault(require("./fi-FI.json"));

var _frFR = _interopRequireDefault(require("./fr-FR.json"));

var _glES = _interopRequireDefault(require("./gl-ES.json"));

var _heIL = _interopRequireDefault(require("./he-IL.json"));

var _hiIN = _interopRequireDefault(require("./hi-IN.json"));

var _hrHR = _interopRequireDefault(require("./hr-HR.json"));

var _huHU = _interopRequireDefault(require("./hu-HU.json"));

var _idID = _interopRequireDefault(require("./id-ID.json"));

var _itIT = _interopRequireDefault(require("./it-IT.json"));

var _jaJP = _interopRequireDefault(require("./ja-JP.json"));

var _kkKZ = _interopRequireDefault(require("./kk-KZ.json"));

var _koKR = _interopRequireDefault(require("./ko-KR.json"));

var _ltLT = _interopRequireDefault(require("./lt-LT.json"));

var _lvLV = _interopRequireDefault(require("./lv-LV.json"));

var _msMY = _interopRequireDefault(require("./ms-MY.json"));

var _nbNO = _interopRequireDefault(require("./nb-NO.json"));

var _nlNL = _interopRequireDefault(require("./nl-NL.json"));

var _plPL = _interopRequireDefault(require("./pl-PL.json"));

var _ptBR = _interopRequireDefault(require("./pt-BR.json"));

var _ptPT = _interopRequireDefault(require("./pt-PT.json"));

var _roRO = _interopRequireDefault(require("./ro-RO.json"));

var _ruRU = _interopRequireDefault(require("./ru-RU.json"));

var _skSK = _interopRequireDefault(require("./sk-SK.json"));

var _slSI = _interopRequireDefault(require("./sl-SI.json"));

var _srCyrlCS = _interopRequireDefault(require("./sr-Cyrl-CS.json"));

var _srLatnCS = _interopRequireDefault(require("./sr-Latn-CS.json"));

var _svSE = _interopRequireDefault(require("./sv-SE.json"));

var _thTH = _interopRequireDefault(require("./th-TH.json"));

var _trTR = _interopRequireDefault(require("./tr-TR.json"));

var _ukUA = _interopRequireDefault(require("./uk-UA.json"));

var _viVN = _interopRequireDefault(require("./vi-VN.json"));

var _yue = _interopRequireDefault(require("./yue.json"));

var _zhCN = _interopRequireDefault(require("./zh-CN.json"));

var _zhHK = _interopRequireDefault(require("./zh-HK.json"));

var _zhTW = _interopRequireDefault(require("./zh-TW.json"));

var _overrides = _interopRequireDefault(require("./overrides.json"));

var _mergeLocalizedStrings = _interopRequireDefault(require("./mergeLocalizedStrings"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Strings commented out are pending official translations
var localizedStrings;

function getAllLocalizedStrings() {
  return localizedStrings || (localizedStrings = (0, _mergeLocalizedStrings.default)({
    'ar-EG': _arEG.default,
    'ar-JO': _arJO.default,
    'ar-SA': _arSA.default,
    'bg-BG': _bgBG.default,
    'ca-ES': _caES.default,
    'cs-CZ': _csCZ.default,
    'da-DK': _daDK.default,
    'de-DE': _deDE.default,
    'el-GR': _elGR.default,
    'en-US': _enUS.default,
    'es-ES': _esES.default,
    'et-EE': _etEE.default,
    'eu-ES': _euES.default,
    'fi-FI': _fiFI.default,
    'fr-FR': _frFR.default,
    'gl-ES': _glES.default,
    'he-IL': _heIL.default,
    'hi-IN': _hiIN.default,
    'hr-HR': _hrHR.default,
    'hu-HU': _huHU.default,
    'id-ID': _idID.default,
    'it-IT': _itIT.default,
    'ja-JP': _jaJP.default,
    'kk-KZ': _kkKZ.default,
    'ko-KR': _koKR.default,
    'lt-LT': _ltLT.default,
    'lv-LV': _lvLV.default,
    'ms-MY': _msMY.default,
    'nb-NO': _nbNO.default,
    'nl-NL': _nlNL.default,
    'pl-PL': _plPL.default,
    'pt-BR': _ptBR.default,
    'pt-PT': _ptPT.default,
    'ro-RO': _roRO.default,
    'ru-RU': _ruRU.default,
    'sk-SK': _skSK.default,
    'sl-SI': _slSI.default,
    'sr-Cyrl': _srCyrlCS.default,
    'sr-Latn': _srLatnCS.default,
    'sv-SE': _svSE.default,
    'th-TH': _thTH.default,
    'tr-TR': _trTR.default,
    'uk-UA': _ukUA.default,
    'vi-VN': _viVN.default,
    yue: _yue.default,
    'zh-Hans': _zhCN.default,
    'zh-Hant': _zhTW.default,
    'zh-Hans-SG': _zhCN.default,
    'zh-Hant-HK': _zhHK.default,
    'zh-Hant-MO': _zhTW.default
  }, _overrides.default));
}

var _default = getAllLocalizedStrings;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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